"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _arEG = _interopRequireDefault(require("./ar-EG.json"));

var _arJO = _interopRequireDefault(require("./ar-JO.json"));

var _arSA = _interopRequireDefault(require("./ar-SA.json"));

var _bgBG = _interopRequireDefault(require("./bg-BG.json"));

var _caES = _interopRequireDefault(require("./ca-ES.json"));

var _csCZ = _interopRequireDefault(require("./cs-CZ.json"));

var _daDK = _interopRequireDefault(require("./da-DK.json"));

var _deDE = _interopRequireDefault(require("./de-DE.json"));

var _elGR = _interopRequireDefault(require("./el-GR.json"));

var _enUS = _interopRequireDefault(require("./en-US.json"));

var _esES = _interopRequireDefault(require("./es-ES.json"));

var _etEE = _interopRequireDefault(require("./et-EE.json"));

var _euES = _interopRequireDefault(require("./eu-ES.json"));

var _fiFI = _interopRequireDefault(require("./fi-FI.json"));

var _frFR = _interopRequireDefault(require("./fr-FR.json"));

var _glES = _interopRequireDefault(require("./gl-ES.json"));

var _heIL = _interopRequireDefault(require("./he-IL.json"));

var _hiIN = _interopRequireDefault(require("./hi-IN.json"));

var _hrHR = _interopRequireDefault(require("./hr-HR.json"));

var _huHU = _interopRequireDefault(require("./hu-HU.json"));

var _idID = _interopRequireDefault(require("./id-ID.json"));

var _itIT = _interopRequireDefault(require("./it-IT.json"));

var _jaJP = _interopRequireDefault(require("./ja-JP.json"));

var _kkKZ = _interopRequireDefault(require("./kk-KZ.json"));

var _koKR = _interopRequireDefault(require("./ko-KR.json"));

var _ltLT = _interopRequireDefault(require("./lt-LT.json"));

var _lvLV = _interopRequireDefault(require("./lv-LV.json"));

var _msMY = _interopRequireDefault(require("./ms-MY.json"));

var _nbNO = _interopRequireDefault(require("./nb-NO.json"));

var _nlNL = _interopRequireDefault(require("./nl-NL.json"));

var _plPL = _interopRequireDefault(require("./pl-PL.json"));

var _ptBR = _interopRequireDefault(require("./pt-BR.json"));

var _ptPT = _interopRequireDefault(require("./pt-PT.json"));

var _roRO = _interopRequireDefault(require("./ro-RO.json"));

var _ruRU = _interopRequireDefault(require("./ru-RU.json"));

var _skSK = _interopRequireDefault(require("./sk-SK.json"));

var _slSI = _interopRequireDefault(require("./sl-SI.json"));

var _srCyrlCS = _interopRequireDefault(require("./sr-Cyrl-CS.json"));

var _srLatnCS = _interopRequireDefault(require("./sr-Latn-CS.json"));

var _svSE = _interopRequireDefault(require("./sv-SE.json"));

var _thTH = _interopRequireDefault(require("./th-TH.json"));

var _trTR = _interopRequireDefault(require("./tr-TR.json"));

var _ukUA = _interopRequireDefault(require("./uk-UA.json"));

var _viVN = _interopRequireDefault(require("./vi-VN.json"));

var _yue = _interopRequireDefault(require("./yue.json"));

var _zhCN = _interopRequireDefault(require("./zh-CN.json"));

var _zhHK = _interopRequireDefault(require("./zh-HK.json"));

var _zhTW = _interopRequireDefault(require("./zh-TW.json"));

var _overrides = _interopRequireDefault(require("./overrides.json"));

var _mergeLocalizedStrings = _interopRequireDefault(require("./mergeLocalizedStrings"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Strings commented out are pending official translations
var localizedStrings;

function getAllLocalizedStrings() {
  return localizedStrings || (localizedStrings = (0, _mergeLocalizedStrings.default)({
    'ar-EG': _arEG.default,
    'ar-JO': _arJO.default,
    'ar-SA': _arSA.default,
    'bg-BG': _bgBG.default,
    'ca-ES': _caES.default,
    'cs-CZ': _csCZ.default,
    'da-DK': _daDK.default,
    'de-DE': _deDE.default,
    'el-GR': _elGR.default,
    'en-US': _enUS.default,
    'es-ES': _esES.default,
    'et-EE': _etEE.default,
    'eu-ES': _euES.default,
    'fi-FI': _fiFI.default,
    'fr-FR': _frFR.default,
    'gl-ES': _glES.default,
    'he-IL': _heIL.default,
    'hi-IN': _hiIN.default,
    'hr-HR': _hrHR.default,
    'hu-HU': _huHU.default,
    'id-ID': _idID.default,
    'it-IT': _itIT.default,
    'ja-JP': _jaJP.default,
    'kk-KZ': _kkKZ.default,
    'ko-KR': _koKR.default,
    'lt-LT': _ltLT.default,
    'lv-LV': _lvLV.default,
    'ms-MY': _msMY.default,
    'nb-NO': _nbNO.default,
    'nl-NL': _nlNL.default,
    'pl-PL': _plPL.default,
    'pt-BR': _ptBR.default,
    'pt-PT': _ptPT.default,
    'ro-RO': _roRO.default,
    'ru-RU': _ruRU.default,
    'sk-SK': _skSK.default,
    'sl-SI': _slSI.default,
    'sr-Cyrl': _srCyrlCS.default,
    'sr-Latn': _srLatnCS.default,
    'sv-SE': _svSE.default,
    'th-TH': _thTH.default,
    'tr-TR': _trTR.default,
    'uk-UA': _ukUA.default,
    'vi-VN': _viVN.default,
    yue: _yue.default,
    'zh-Hans': _zhCN.default,
    'zh-Hant': _zhTW.default,
    'zh-Hans-SG': _zhCN.default,
    'zh-Hant-HK': _zhHK.default,
    'zh-Hant-MO': _zhTW.default
  }, _overrides.default));
}

var _default = getAllLocalizedStrings;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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